/* umozni pouzit string ako index v objektoch... error:  
expression of type 'string' can't be used to index type,
No index signature with a parameter of type 'string' was found on type
*/

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const _getKeyValue_ = (key: string) => (obj: Record<string, any>) => obj[key];
